// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import { Container, Menu, Icon } from 'semantic-ui-react'
import fire from '../config/Fire'
import logo from '../assets/logo.png'

export default class DropdownMenu extends Component {
  constructor (props) {
    super(props)
    this.state = {
      error: null
    }
  }

  logout () {
    fire.auth().signOut()
    window.scrollTo(0, 0)
  }

  render () {
    let { visible } = this.props
    return (
      <Menu
        borderless
        inverted
        style={{
          border: 'none',
          borderRadius: 0,
          boxShadow: 'none',
          marginBottom: '0em',
          backgroundColor: '#000',
          color: '#fff'
        }}>
        <Container>
          <Menu.Item>
            <img src={`${logo}`} href='/' style={{ width: '30px', margin: '0.7vh' }} alt='logo' />
          </Menu.Item>
          <Menu.Item header href='/'>
            <span style={{color:'#fff'}}>
              <b>
              Murkstom
              </b>
            </span>
          </Menu.Item>

          {!visible && (
            <Menu.Item position='right' onClick={() => this.props.handleShowClick()}>
              <Icon name='bars' />
              Menu
            </Menu.Item>
          )}
          {visible &&
            <Menu.Item position='right' onClick={() => this.props.handleHideClick()}>
              <Icon name='close'/>
              Close
            </Menu.Item>
          }
        </Container>
      </Menu>
    )
  }
}
